(() => {
  if (window.BandenmeestersCartRuntimeLoaded) {
    window.BandenmeestersCartRenderVehicle?.();
    return;
  }
  window.BandenmeestersCartRuntimeLoaded = true;
  const deliveryKeys = ['recipientName', 'addressLine1', 'addressLine2', 'city', 'phone'];
  // Volatile draft belongs to the cart owner and survives its own section refresh.
  // Never copy delivery PII to storage, cart attributes, line properties or URLs.
  const deliveryDraft = {};
  const deliveryFields = () => [...document.querySelectorAll('[data-bm-new-delivery-field]')]
    .filter(field => deliveryKeys.includes(field.dataset.bmNewDeliveryField));
  const postcodeField = () => document.querySelector('[data-bm-new-delivery-postcode]');
  const readCheckoutDelivery = () => Object.fromEntries(deliveryFields().map(field => [field.dataset.bmNewDeliveryField, field.value.trim()]));
  const rememberDelivery = () => {
    for (const field of deliveryFields()) deliveryDraft[field.dataset.bmNewDeliveryField] = field.value;
    const postcode = postcodeField();
    if (postcode) deliveryDraft.postalCode = postcode.value;
  };
  const restoreDelivery = () => {
    for (const field of deliveryFields()) {
      if (!field.value && deliveryDraft[field.dataset.bmNewDeliveryField]) field.value = deliveryDraft[field.dataset.bmNewDeliveryField];
      field.readOnly = newPreflightBusy;
    }
    const postcode = postcodeField();
    if (postcode) {
      if (!postcode.value && deliveryDraft.postalCode) postcode.value = deliveryDraft.postalCode;
      postcode.readOnly = newPreflightBusy;
    }
  };

  const normalizePath = (value) => {
    if (!value) return '';
    try { return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/'; }
    catch (error) { return String(value).split('?')[0].split('#')[0].replace(/\/$/, ''); }
  };

  const splitData = (value) => String(value || '').split('|').map((entry) => entry.trim()).filter(Boolean);

  // Bridge owns the active generation binding. A null binding must not revive
  // an older legacy URL; USED still compares only its existing projections.
  const activeGenerationUrl = vehicle => vehicle?.newVehicle ? null : normalizePath(vehicle?.generation?.url);

  const resolveLineFitment = (line, vehicle) => {
    if (!vehicle || line?.dataset?.productType !== 'Velgenset') return null;
    const activeUrl = activeGenerationUrl(vehicle);
    const legacyIdIsCurrent = !vehicle.newVehicle || (activeUrl && normalizePath(vehicle.generation?.url) === activeUrl);
    const ids = splitData(line.dataset.fitmentIds);
    if (ids.length && vehicle.generation?.id && legacyIdIsCurrent) return ids.includes(String(vehicle.generation.id));
    const urls = splitData(line.dataset.fitmentUrls).map(normalizePath).filter(Boolean);
    if (urls.length && activeUrl) return urls.includes(activeUrl);
    return null;
  };

  const renderLineFitment = (vehicle) => {
    const uniqueResults = new Map();
    document.querySelectorAll('[data-bm-cart-line]').forEach((line, index) => {
      const status = line.querySelector('[data-bm-line-fitment]');
      const text = status?.querySelector('[data-bm-line-fitment-text]');
      const isWheelset = line.dataset.productType === 'Velgenset';
      if (!status || !isWheelset || !vehicle) {
        if (status) status.hidden = true;
        return;
      }

      const result = resolveLineFitment(line, vehicle);
      const resultKey = line.dataset.variantId || `line-${index}`;
      if (!uniqueResults.has(resultKey)) uniqueResults.set(resultKey, result);
      status.hidden = false;
      status.classList.remove('is-match', 'is-warning', 'is-neutral');
      if (result === true) {
        status.classList.add('is-match');
        if (text) text.textContent = 'Gekoppeld aan jouw gekozen generatie';
      } else if (result === false) {
        status.classList.add('is-warning');
        if (text) text.textContent = 'Niet gekoppeld aan jouw gekozen generatie';
      } else {
        status.classList.add('is-neutral');
        if (text) text.textContent = 'Pasvorm nog te controleren';
      }
    });
    return [...uniqueResults.values()];
  };



  // NEW cart keeps the selected vehicle without a second supplier lookup.
  const newCartRows = () => [...document.querySelectorAll('[data-bm-new-cart-line]')];
  // PDP shows the supplier match; only the P8 Quote authorizes checkout.
  const renderNewLineFitment = vehicle => {
    const vehicleId = window.BandenmeestersVehicle?.getNewVehicle?.()?.vehicleId || '';
    const selected = Boolean(vehicleId && vehicle?.newVehicle?.vehicleId === vehicleId);
    for (const row of newCartRows()) {
      const status = row.querySelector?.('[data-bm-line-fitment]');
      if (!status) continue;
      status.hidden = !selected || row.dataset.productType === 'Nieuwe banden';
      status.classList.remove('is-match', 'is-warning');
      status.classList.add('is-neutral');
      const text = status.querySelector('[data-bm-line-fitment-text]');
      if (text && !status.hidden) text.textContent = 'Gekozen voor jouw auto';
    }
    return { blocked: false, allMatched: false };
  };

  // Only the existing canonical generation resource may supply cart vehicle media.
  const photoRequests = new Map();
  let vehiclePhotoVersion = 0;
  const generationPhotoPath = vehicle => {
    if (vehicle?.newVehicle) return '';
    const raw = vehicle?.newVehicle ? vehicle.newVehicle.vehiclePageUrl || '' : vehicle?.generation?.url || '';
    if (!raw) return '';
    try {
      const target = new URL(raw, window.location.origin);
      const preview = window.location.hostname === 'shopifypreview.com'
        || window.location.hostname.endsWith('.shopifypreview.com');
      const domain = document.querySelector('[data-bm-mobile-menu-overlay]')?.dataset.bmPrimaryShopDomain || '';
      const primaryOrigin = /^[a-z0-9.-]+$/i.test(domain) ? new URL('https://' + domain).origin : '';
      if (target.origin !== window.location.origin && !(preview && target.origin === primaryOrigin)) return '';
      if (target.search || target.hash || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/.test(target.pathname)) return '';
      return target.pathname.replace(/\/$/, '');
    } catch (_) { return ''; }
  };
  const cachedVehiclePhoto = (vehicle, key) => {
    if (vehicle?.generation?.image) return vehicle.generation.image;
    try {
      const cache = JSON.parse(window.localStorage.getItem('bm_generation_image_cache_v1') || '{}') || {};
      return cache[key] || (vehicle?.generation?.id && cache[String(vehicle.generation.id)]) || '';
    } catch (_) { return ''; }
  };
  const loadVehiclePhoto = key => {
    if (photoRequests.has(key)) return photoRequests.get(key);
    const pending = (async () => {
      try {
        const response = await fetch(key, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) return '';
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('[data-bm-canonical-generation-image]');
        if (!source?.dataset.bmCanonicalGenerationImage) return '';
        const parent = new URL(source.dataset.bmCanonicalGenerationHref || '', window.location.origin);
        if (parent.pathname.replace(/\/$/, '') !== key) return '';
        const photo = new URL(source.dataset.bmCanonicalGenerationImage, window.location.origin);
        const original = window.location.origin;
        const primary = document.querySelector('[data-bm-mobile-menu-overlay]')?.dataset.bmPrimaryShopDomain || '';
        const trusted = photo.origin === original || photo.hostname === 'cdn.shopify.com'
          || (primary && photo.hostname === primary && photo.pathname.startsWith('/cdn/'));
        if (!trusted || photo.protocol !== 'https:') return '';
        try {
          const cache = JSON.parse(window.localStorage.getItem('bm_generation_image_cache_v1') || '{}') || {};
          cache[key] = photo.href;
          window.localStorage.setItem('bm_generation_image_cache_v1', JSON.stringify(cache));
        } catch (_) {}
        return photo.href;
      } catch (_) { return ''; }
    })().finally(() => photoRequests.delete(key));
    photoRequests.set(key, pending);
    return pending;
  };
  const loadExactVehiclePhoto = (vehicle, themeRole, themeId) =>
    window.BandenmeestersVehicle?.photoFor?.(vehicle, { themeRole, themeId }) || Promise.resolve('');

  const renderVehiclePhoto = vehicle => {
    const containers = [...document.querySelectorAll('[data-bm-cart-vehicle]')]
      .filter(node => node.querySelector('[data-bm-cart-vehicle-image]'));
    if (!containers.length) return;
    const version = ++vehiclePhotoVersion;
    const key = vehicle ? generationPhotoPath(vehicle) : '';
    const show = photo => {
      if (version !== vehiclePhotoVersion) return;
      containers.forEach(container => {
        const image = container.querySelector('[data-bm-cart-vehicle-image]');
        const icon = container.querySelector('[data-bm-cart-vehicle-icon]');
        if (!image) return;
        if (!photo) {
          image.hidden = true;
          image.removeAttribute('src');
          if (icon) icon.toggleAttribute('hidden', false);
          return;
        }
        image.onload = () => { if (version === vehiclePhotoVersion) { image.hidden = false; if (icon) icon.toggleAttribute('hidden', true); } };
        image.onerror = () => { if (version !== vehiclePhotoVersion) return; image.hidden = true; if (icon) icon.toggleAttribute('hidden', false); };
        image.alt = window.BandenmeestersVehicle?.vehicleLabel?.(vehicle) || 'Gekozen auto';
        // Hidden lazy images cannot fire the load event that reveals them.
        image.loading = 'eager';
        image.decoding = 'async';
        image.src = photo;
        if (image.complete && image.naturalWidth) { image.hidden = false; if (icon) icon.toggleAttribute('hidden', true); }
      });
    };
    const known = vehicle?.newVehicle?.image || (vehicle && !vehicle.newVehicle && cachedVehiclePhoto(vehicle, key));
    show(known || '');
    if (vehicle?.newVehicle && !known) {
      loadExactVehiclePhoto(vehicle, containers[0]?.dataset.bmThemeRole || '', containers[0]?.dataset.bmThemeId || '').then(photo => {
        if (version !== vehiclePhotoVersion || window.BandenmeestersVehicle?.getActive?.()?.newVehicle?.vehicleId !== vehicle.newVehicle.vehicleId) return;
        show(photo);
      });
      return;
    }
    if (!vehicle || !key || known) return;
    loadVehiclePhoto(key).then(photo => {
      const current = window.BandenmeestersVehicle?.getActive?.();
      if (version !== vehiclePhotoVersion || generationPhotoPath(current) !== key
        || String(current?.newVehicle?.vehicleId || current?.generation?.id || '') !==
           String(vehicle?.newVehicle?.vehicleId || vehicle?.generation?.id || '')) return;
      show(photo);
    });
  };

  let acknowledgedMismatch = null;
  let currentMismatch = null;
  const renderVehicle = () => {
    restoreDelivery();
    const api = window.BandenmeestersVehicle;
    const vehicle = api?.getActive?.() || null;
    const label = vehicle ? (api?.vehicleLabel?.(vehicle) || [vehicle?.brand?.name, vehicle?.generation?.name || vehicle?.model?.name].filter(Boolean).join(' ')) : '';
    const results = renderLineFitment(vehicle);
    const newFitment = renderNewLineFitment(vehicle);
    const hasMismatch = results.some((result) => result === false);
    const signature = hasMismatch ? JSON.stringify([
      vehicle?.generation?.id, activeGenerationUrl(vehicle), vehicle?.newVehicle?.vehicleId,
      [...document.querySelectorAll('[data-bm-cart-line],[data-bm-new-cart-line]')].map(line => [
        line.dataset.lineKey, line.dataset.variantId, line.dataset.lineQuantity, line.dataset.lineTotal,
        line.dataset.fitmentIds, line.dataset.fitmentUrls,
      ]),
    ]) : null;
    if (signature !== currentMismatch) acknowledgedMismatch = null;
    currentMismatch = signature;
    const needsAcknowledgement = hasMismatch && acknowledgedMismatch !== signature;
    document.querySelectorAll('[data-bm-cart-checkout]').forEach(button => { button.disabled = newPreflightBusy || newCartQuantityBusy || newCartQuantityQueued || needsAcknowledgement || newFitment.blocked; });
    document.querySelectorAll('[data-bm-mismatch-gate]').forEach(gate => { gate.hidden = !needsAcknowledgement; });
    const hasNew = document.querySelectorAll('[data-bm-new-cart-line]').length > 0;
    const onlyLooseTyres = newCartRows().length > 0 && newCartRows().every(row => row.dataset.productType === 'Nieuwe banden')
      && document.querySelectorAll('[data-bm-cart-line]').length === 0;
    const hasUnknown = (hasNew && !newFitment.allMatched) || results.some((result) => result === null);
    const allMatched = !hasNew && results.length > 0 && results.every((result) => result === true);

    document.querySelectorAll('[data-bm-cart-vehicle]').forEach((root) => {
      root.hidden = onlyLooseTyres;
      const title = root.querySelector('[data-bm-cart-vehicle-label]');
      const detail = root.querySelector('[data-bm-cart-vehicle-detail]');
      const action = root.querySelector('[data-bm-vehicle-change-link]');
      root.classList.remove('has-vehicle', 'is-warning', 'is-match', 'is-neutral');
      root.classList.add(vehicle ? 'has-vehicle' : 'is-neutral');

      if (title) title.textContent = vehicle ? label : 'Kies je auto';
      if (action) action.textContent = vehicle ? 'Wijzig auto' : 'Kies auto';

      if (!detail) return;
      if (!vehicle) {
        detail.textContent = 'Selecteer je auto om velgen en pasvorm te bekijken.';
      } else if (hasMismatch) {
        root.classList.add('is-warning');
        if (newFitment.blocked) {
          detail.textContent = 'Er staan velgen in je winkelwagen die niet geschikt zijn voor jouw gekozen auto. Bekijk de melding bij ieder product.';
        } else detail.textContent = results.length === 1
          ? 'Deze set is niet gekoppeld aan jouw gekozen generatie. Controleer de passing vóór bestellen.'
          : 'Minstens één set is niet gekoppeld aan jouw gekozen generatie. Controleer de passing vóór bestellen.';
      } else if (newFitment.blocked) {
        root.classList.add('is-warning');
        detail.textContent = 'De gekozen nieuwe velgmaat is niet geschikt voor jouw auto. Bekijk een passende maat of wijzig je auto.';
      } else if (hasNew && newFitment.allMatched && results.every(result => result === true)) {
        root.classList.add('is-match');
        detail.textContent = 'Deze velgen passen volgens leveranciersgegevens bij jouw auto.';
      } else if (allMatched) {
        root.classList.add('is-match');
        detail.textContent = results.length === 1
          ? 'Deze set is gekoppeld aan jouw gekozen generatie.'
          : 'Alle velgensets zijn gekoppeld aan jouw gekozen generatie.';
      } else if (hasNew) {
        root.classList.add('is-neutral');
        detail.textContent = 'Je gekozen auto blijft bij je bestelling bewaard.';
      } else if (hasUnknown || !results.length) {
        root.classList.add('is-neutral');
        detail.textContent = 'Niet iedere velg is als passend voor jouw auto bevestigd. Controleer de producten afzonderlijk.';
      }
    });
    renderVehiclePhoto(vehicle);
  };

  window.BandenmeestersCartRenderVehicle = renderVehicle;

  let newPreflightBusy = false;
  const cartJson = async (path, body, signal) => {
    const response = await fetch(path, { credentials: 'same-origin', cache: 'no-store',
      signal,
      ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : {}) });
    const result = await response.json();
    if (!response.ok || result.errors || !Array.isArray(result.items)) throw new Error('cart_unavailable');
    return result;
  };
  // Canonical S5/P9 NEW wheel quantity change. This is an unconfirmed cart intent:
  // the exact quantity must still pass a fresh P8 Quote before checkout.
  let newCartQuantityBusy = false;
  let newCartQuantityQueued = false;
  let quantityDraftRow = null;
  let quantityDraftTimer = null;
  // P12 catalogue metadata is a short-lived UI check, NOT stock or checkout authority.
  // Never refetch the supplier data for each rapid + / - click.
  const newQuantityCatalogCache = new Map();
  const cachedNewQuantityCatalog = async productRef => {
    const key = String(productRef);
    const saved = newQuantityCatalogCache.get(key);
    if (saved?.expires > Date.now()) return saved.value;
    if (saved?.pending) return saved.pending;
    const client = window.BandenmeestersNewClient;
    if (!client?.productCatalog) throw new Error('catalog_unavailable');
    const pending = client.productCatalog(key).then(value => {
      if (!Array.isArray(value?.product?.setOptions)) throw new Error('catalog_unavailable');
      if (newQuantityCatalogCache.size > 16) newQuantityCatalogCache.clear();
      newQuantityCatalogCache.set(key, { value, expires: Date.now() + 60000 });
      return value;
    }).catch(error => { newQuantityCatalogCache.delete(key); throw error; });
    newQuantityCatalogCache.set(key, { pending });
    return pending;
  };
  const cartChangeAjaxUrl = () => {
    // Shopify routes.cart_change_url is /cart/change (HTML form route), not AJAX.
    // Only the same-store JSON endpoint can satisfy cartJson() readback.
    const path = String(window.routes?.cart_change_url || '/cart/change').trim();
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/change(?:\.js)?$/.test(path)) {
      throw new Error('cart_unavailable');
    }
    return path.endsWith('.js') ? path : `${path}.js`;
  };
  const newQuantityError = (row, message) => {
    const output = row?.querySelector?.('[data-bm-cart-qty-status]');
    if (output) output.textContent = message;
  };
  const validNewQuantityRequest = (option, variantId, quantity, unitPrice) => {
    if (option?.setType !== 'SQUARE' || option.defaultQuantity !== 4 ||
        String(option.shopifyVariantBinding?.shopifyVariantId) !== String(variantId) ||
        option.unitPrice?.currency !== 'EUR' || option.unitPrice?.amountCents !== unitPrice) return false;
    const request = option.quantityRequest;
    if (!request) return quantity === 4;
    if (request.contract !== 'BM_PHYSICAL_WHEEL_QUANTITY_REQUEST_V1' ||
        request.unit !== 'PHYSICAL_WHEEL' || request.authorization !== 'PER_QUANTITY_QUOTE_REQUIRED' ||
        request.defaultQuantity !== 4 || request.minQuantity !== 1 || request.maxQuantity !== 20) return false;
    if (Array.isArray(option.allowedQuantities) && !option.allowedQuantities.includes(quantity)) return false;
    return Number.isSafeInteger(quantity) && quantity >= request.minQuantity && quantity <= request.maxQuantity;
  };

  async function changeNewWheelQuantity(row, proposed) {
    const input = row?.querySelector?.('[data-bm-cart-qty-input]');
    const present = Number(row?.dataset?.lineQuantity);
    if (!input || !Number.isSafeInteger(proposed) || proposed < 1 || proposed > 20 ||
        !Number.isSafeInteger(present)) {
      if (input) input.value = String(present);
      newQuantityError(row, 'Kies een geheel aantal van 1 tot 20 velgen.');
      return;
    }
    if (proposed === present || newCartQuantityBusy || newPreflightBusy) {
      input.value = String(present);
      return;
    }
    newCartQuantityBusy = true;
    let wrote = false;
    const controls = [...row.querySelectorAll('[data-bm-cart-qty-input],[data-bm-cart-qty-delta]')];
    controls.forEach(control => { control.disabled = true; });
    row.setAttribute('aria-busy', 'true');
    newQuantityError(row, 'Winkelwagen bijwerken…');
    renderVehicle();
    try {
      await Promise.all([...document.querySelectorAll('cart-items,mini-cart')].map(owner => owner.whenSettled?.()));
      const before = await cartJson('/cart.js');
      const line = before.items.find(item => item.key === row.dataset.lineKey);
      if (!line || before.currency !== 'EUR' ||
          String(line.variant_id) !== row.dataset.variantId ||
          line.quantity !== present || String(line.final_line_price) !== row.dataset.lineTotal)
        throw new Error('cart_changed');
      const context = readContext(line);
      if (context.v !== 1) throw new Error('configuration_required');
      const catalog = await cachedNewQuantityCatalog(context.productRef);
      const options = catalog?.product?.setOptions?.filter(option => option.setId === context.setId) || [];
      if (options.length !== 1 ||
          !validNewQuantityRequest(options[0], line.variant_id, proposed, line.final_price))
        throw new Error('quantity_unavailable');

      // Another tab, discount or add/remove must not change the initial cart while validating.
      const fresh = await cartJson('/cart.js');
      if (composition(fresh) !== composition(before)) throw new Error('cart_changed');
      const oldContext = JSON.parse(line.properties?._bm_ctx || '{}');
      const properties = { ...line.properties, _bm_ctx: JSON.stringify({ ...oldContext, quantity: proposed }) };
      delete properties._bm_ref;
      const response = await cartJson(cartChangeAjaxUrl(), {
        id: line.key, quantity: proposed, properties,
      });
      wrote = true;
      const receipt = await cartJson('/cart.js');
      const matches = receipt.items.filter(item =>
        String(item.variant_id) === String(line.variant_id) &&
        (() => { try { const ctx = JSON.parse(item.properties?._bm_ctx || '{}');
          return ctx.v === 1 && ctx.setId === context.setId && ctx.productRef === context.productRef;
        } catch (_) { return false; } })());
      const otherBefore = before.items.filter(item => item.key !== line.key)
        .map(item => [String(item.variant_id), item.quantity, item.final_line_price, propertiesSignature(item.properties)]).sort();
      const otherAfter = receipt.items.filter(item => !matches.includes(item))
        .map(item => [String(item.variant_id), item.quantity, item.final_line_price, propertiesSignature(item.properties)]).sort();
      if (receipt.items.length !== before.items.length || matches.length !== 1 ||
          matches[0].quantity !== proposed || matches[0].properties?._bm_ref ||
          JSON.stringify(otherBefore) !== JSON.stringify(otherAfter) ||
          response.item_count !== receipt.item_count) throw new Error('cart_receipt_unconfirmed');

      for (const owner of document.querySelectorAll('cart-items,mini-cart')) {
        if (typeof owner.updateSectionContents === 'function') await owner.updateSectionContents();
      }
      document.dispatchEvent(new CustomEvent('cart:item-quantity-update', {
        detail: { cart: receipt, context: 'bm-new-physical-quantity' },
      }));
      newQuantityError(row, '');
      newCartMessage('Aantal bijgewerkt.');
    } catch (error) {
      if (wrote) {
        // An uncertain remote mutation requires readback, never a blind replay.
        window.location.reload();
        return;
      }
      input.value = String(present);
      newQuantityError(row, ({
        configuration_required: 'Deze gecombineerde samenstelling kan niet los worden gewijzigd.',
        quantity_unavailable: 'Dit aantal kan momenteel niet worden bevestigd.',
        catalog_unavailable: 'Beschikbare aantallen konden niet worden gecontroleerd.',
        cart_changed: 'Je winkelwagen is gewijzigd. Vernieuw en probeer opnieuw.',
      })[error?.message] || 'Aanpassen is niet gelukt. Probeer opnieuw.');
    } finally {
      newCartQuantityBusy = false;
      row.removeAttribute('aria-busy');
      controls.forEach(control => { control.disabled = false; });
      updateQuantityButtons(row, Number(input.value));
      renderVehicle();
    }
  }

  function updateQuantityButtons(row, value) {
    for (const [delta, atLimit] of [[-1, value <= 1], [1, value >= 20]]) {
      const control = row?.querySelector?.('[data-bm-cart-qty-delta="' + delta + '"]');
      if (control) control.disabled = atLimit;
    }
  }

  // Immediate numeric feedback. Only the last value of a short tap burst
  // triggers one guarded Shopify cart update; no provider GET per button press.
  function queueNewWheelQuantity(row, proposed) {
    const input = row?.querySelector?.('[data-bm-cart-qty-input]');
    const present = Number(row?.dataset?.lineQuantity);
    if (!input || !Number.isSafeInteger(proposed) || proposed < 1 || proposed > 20 ||
        !Number.isSafeInteger(present)) {
      if (input) input.value = String(present);
      newQuantityError(row, 'Kies een heel aantal van 1 tot 20 velgen.');
      updateQuantityButtons(row, present);
      return;
    }
    if (newPreflightBusy || newCartQuantityBusy || (quantityDraftRow && quantityDraftRow !== row)) {
      if (!newCartQuantityQueued) input.value = String(present);
      newQuantityError(row, 'Wacht tot de vorige aanpassing is verwerkt.');
      return;
    }
    if (quantityDraftTimer !== null) clearTimeout(quantityDraftTimer);
    quantityDraftTimer = null;
    if (proposed === present) {
      input.value = String(present);
      quantityDraftRow = null; newCartQuantityQueued = false;
      newQuantityError(row, ''); updateQuantityButtons(row, present);
      renderVehicle();
      return;
    }
    input.value = String(proposed);
    updateQuantityButtons(row, proposed);
    newQuantityError(row, '');
    quantityDraftRow = row; newCartQuantityQueued = true;
    renderVehicle();
    quantityDraftTimer = setTimeout(() => {
      quantityDraftTimer = null; quantityDraftRow = null; newCartQuantityQueued = false;
      return changeNewWheelQuantity(row, proposed);
    }, 420);
  }

  const propertiesSignature = properties => JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
  const composition = cart => JSON.stringify([cart.currency, cart.items.map(line => [String(line.variant_id), String(line.product_id), line.quantity, line.final_price, line.final_line_price, propertiesSignature(line.properties)])]);
  const readContext = line => {
    let context;
    try { context = JSON.parse(line.properties?._bm_ctx); } catch (_) { throw new Error('context_required'); }
    const uuid = value => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
    if (context?.v === 2) {
      if (!uuid(context.groupId) || !uuid(context.skuId) || !['WHEEL','TYRE'].includes(context.kind) || !['ALL','FRONT','REAR'].includes(context.position) ||
          !Array.isArray(context.members) || context.members.length < 1 || context.members.length > 3 ||
          context.members.some(m => !uuid(m.skuId) || !['WHEEL','TYRE'].includes(m.kind) || !['ALL','FRONT','REAR'].includes(m.position) ||
            !/^[1-9]\d*$/.test(m.variantId || '') || !Number.isInteger(m.quantity) || m.quantity < 1 || m.quantity > 20) ||
          new Set(context.members.map(m => m.variantId)).size !== context.members.length) throw new Error('context_required');
      const member = context.members.filter(m => m.skuId === context.skuId && m.kind === context.kind && m.position === context.position && m.variantId === String(line.variant_id));
      if (member.length !== 1 || member[0].quantity !== line.quantity) throw new Error('context_required');
      const vehicleBound = context.members.some(m => m.kind === 'WHEEL');
      if (vehicleBound ? !uuid(context.vehicleId) || !uuid(context.setId) : context.vehicleId || context.setId) throw new Error('context_required');
      return { v: 2, kind: context.kind, skuId: context.skuId, position: context.position, groupId: context.groupId, members: context.members,
        ...(vehicleBound ? { vehicleId: context.vehicleId, setId: context.setId } : {}) };
    }
    if (context?.v !== 1 || !uuid(context.setId) || (context.vehicleId && !uuid(context.vehicleId))
      || String(context.productRef) !== String(line.product_id) || !Number.isSafeInteger(line.quantity)
      || line.quantity < 1 || line.quantity > 20) throw new Error('context_required');
    return { v: 1, productRef: String(line.product_id), setId: context.setId,
      ...(context.vehicleId ? { vehicleId: context.vehicleId } : {}) };
  };
  const normalizeBelgianPostcode = value => {
    const postcode = String(value || '').trim();
    return /^[1-9][0-9]{3}$/.test(postcode) ? postcode : '';
  };
  const validatedCheckoutDelivery = address => {
    if (!address) throw new Error('delivery_address_required');
    if (deliveryKeys.some(key => address[key] != null && typeof address[key] !== 'string')) {
      throw new Error('delivery_fields_invalid');
    }
    const cleaned = Object.fromEntries(deliveryKeys.filter(key => typeof address[key] === 'string' && address[key].trim())
      .map(key => [key, address[key].trim()]));
    if (['recipientName', 'addressLine1', 'city', 'phone'].some(key => !cleaned[key])) {
      throw new Error('delivery_address_required');
    }
    if (['recipientName', 'addressLine1', 'addressLine2'].some(key => (cleaned[key] || '').length > 200)
      || cleaned.city.length > 100 || cleaned.phone.length > 40) {
      throw new Error('delivery_fields_invalid');
    }
    // Spaces, brackets and dashes are formatting only; never silently replace
    // an incorrect country code or an absent phone number.
    if (!/^\+?[0-9 ()-]+$/.test(cleaned.phone)) throw new Error('delivery_phone_invalid');
    let digits = cleaned.phone.replace(/[ ()-]/g, '');
    if (digits.startsWith('+')) digits = digits.slice(1);
    else if (digits.startsWith('00')) digits = digits.slice(2);
    else if (/^0[1-9][0-9]{7,8}$/.test(digits)) digits = '32' + digits.slice(1);
    if (!/^[1-9][0-9]{7,14}$/.test(digits) || /^320/.test(digits)) {
      throw new Error('delivery_phone_invalid');
    }
    return Object.freeze(cleaned);
  };
  const checkoutPostalCode = () => normalizeBelgianPostcode(postcodeField()?.value);
  const currentNewVehicleId = () => {
    const id = window.BandenmeestersVehicle?.getNewVehicle?.()?.vehicleId;
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id || '')) throw new Error('vehicle_required');
    return id;
  };
  const quoteIsFresh = quote => Number.isFinite(Date.parse(quote?.expiresAt)) && Date.parse(quote.expiresAt) > Date.now();
  async function revalidateNewCart(options = {}, controls = {}) {
    const controller = new AbortController();
    let timeout;
    const deadline = new Promise((_, reject) => {
      timeout = setTimeout(() => {
        controller.abort();
        reject(new Error('cart_timeout'));
      }, 30000);
    });
    try {
      return await Promise.race([validateNewCart(options, { ...controls, signal: controller.signal }), deadline]);
    } finally {
      clearTimeout(timeout);
      controller.abort();
    }
  }
  async function validateNewCart({ commit = false, postalCode = '', deliveryAddress } = {}, { isDeliveryCurrent = () => true, signal } = {}) {
    const ensureActive = () => { if (signal.aborted) throw new Error('cart_timeout'); };
    const initial = await cartJson('/cart.js', undefined, signal);
    ensureActive();
    // The active cart page supplies NEW classification and USED mismatch UI.
    // A changed cart from another tab must be rendered before either can be used.
    // Never infer an unrendered product's type or silently ignore missing _bm_ctx.
    const root = document.querySelector('.bm-cart-page') || document;
    const rendered = new Map([...root.querySelectorAll('[data-bm-cart-line],[data-bm-new-cart-line]')]
      .map(node => [node.dataset.lineKey, node.dataset]));
    if (rendered.size !== initial.items.length || initial.items.some(line => {
      const row = rendered.get(line.key);
      return !row || String(line.variant_id) !== row.variantId
        || String(line.quantity) !== row.lineQuantity || String(line.final_line_price) !== row.lineTotal;
    })) throw new Error('cart_changed');
    const knownNew = new Set([...document.querySelectorAll('[data-bm-new-cart-line]')].map(line => line.dataset.variantId));
    const candidates = initial.items.map((line, index) => ({ line, index })).filter(({ line }) => knownNew.has(String(line.variant_id)) || line.properties?._bm_ref || line.properties?._bm_ctx);
    if (!candidates.length) return initial;
    const exactDelivery = validatedCheckoutDelivery(deliveryAddress);
    if (initial.currency !== 'EUR') throw new Error('currency_changed');
    const postcode = normalizeBelgianPostcode(postalCode);
    if (!postcode) throw new Error('postcode_required');
    const contexts = candidates.map(c => ({ ...c, context: readContext(c.line) }));
    const vehicleBound = contexts.some(c => c.context.v === 1 || c.context.members.some(m => m.kind === 'WHEEL'));
    const vehicleId = vehicleBound ? currentNewVehicleId() : null;
    const ensureVehicle = () => {
      ensureActive();
      if (vehicleBound && currentNewVehicleId() !== vehicleId) throw new Error('vehicle_changed');
      if (!isDeliveryCurrent()) throw new Error('delivery_changed');
    };
    const checked = [];
    const physicalGroups = new Map();
    for (const candidate of contexts.filter(c => c.context.v === 2)) {
      const { context } = candidate;
      if (context.vehicleId && context.vehicleId !== vehicleId) throw new Error('vehicle_changed');
      if (!physicalGroups.has(context.groupId)) physicalGroups.set(context.groupId, []);
      physicalGroups.get(context.groupId).push(candidate);
    }
    for (const group of physicalGroups.values()) {
      const context = group[0].context;
      if (group.length !== context.members.length || group.some(c => JSON.stringify(c.context.members) !== JSON.stringify(context.members) || c.context.vehicleId !== context.vehicleId || c.context.setId !== context.setId) ||
          context.members.some(m => group.filter(c => String(c.line.variant_id) === m.variantId && c.line.quantity === m.quantity && c.context.skuId === m.skuId && c.context.kind === m.kind && c.context.position === m.position).length !== 1)) throw new Error('context_required');
    }
    // The authoritative P8 Quote checks vehicle, ALZURA supplier match,
    // SKU, variant, price and availability. Do not repeat its two GETs.
    for (const { line, index, context } of contexts.filter(c => c.context.v === 1)) {
      checked.push({ line, index, context: { ...context, vehicleId } });
    }
    if (composition(await cartJson('/cart.js', undefined, signal)) !== composition(initial)) throw new Error('cart_changed');
    ensureVehicle();
    const prepared = [];
    // The validated delivery stays in memory only, never in cart properties.
    // The customer must confirm identical shipping details in Shopify checkout.
    for (const group of physicalGroups.values()) {
      const context = group[0].context, hasWheel = context.members.some(m => m.kind === 'WHEEL');
      const quote = await window.BandenmeestersNewClient.physicalQuote({ requestId: crypto.randomUUID(), postalCode: postcode,
        deliveryAddress: exactDelivery, ...(hasWheel ? { vehicleId, setId: context.setId } : {}),
        lines: group.map(c => ({ kind: c.context.kind, skuId: c.context.skuId, position: c.context.position, quantity: c.line.quantity })) }, { signal });
      ensureVehicle();
      if (!quoteIsFresh(quote)) throw new Error('quote_expired');
      const reference = await window.BandenmeestersNewClient.cartReference(quote, { signal });
      ensureVehicle();
      if (reference.lines.length !== group.length) throw new Error('price_or_configuration_changed');
      for (const { line, index, context: currentContext } of group) {
        const physical = reference.lines.filter(l => String(l.shopifyVariantId) === String(line.variant_id));
        const p = physical[0];
        if (physical.length !== 1 || p.shopifyQuantity !== line.quantity || p.unitRetailPriceCents !== line.final_price || p.lineTotalCents !== line.final_line_price ||
            p.lineProperty?.name !== '_bm_ref' || typeof p.lineProperty.value !== 'string' || !p.lineProperty.value.trim()) throw new Error('price_or_configuration_changed');
        prepared.push({ index, quote, properties: { ...line.properties, _bm_ref: p.lineProperty.value,
          _bm_ctx: JSON.stringify({ ...currentContext, expiresAt: quote.expiresAt }) } });
      }
    }
    for (const { line, index, context } of checked) {
      const quoteContext = { ...context, postalCode: postcode, quantity: line.quantity };
      const quote = await window.BandenmeestersNewClient.quote({ ...quoteContext, deliveryAddress: exactDelivery, requestId: crypto.randomUUID() }, { signal });
      ensureVehicle();
      if (!quoteIsFresh(quote)) throw new Error('quote_expired');
      const reference = await window.BandenmeestersNewClient.cartReference(quote, { signal });
      ensureVehicle();
      const physical = reference.lines[0];
      if (reference.lines.length !== 1 || String(physical.shopifyVariantId) !== String(line.variant_id) || physical.shopifyQuantity !== line.quantity
        || physical.lineTotalCents !== line.final_line_price || physical.unitRetailPriceCents !== line.final_price
        || physical.lineProperty?.name !== '_bm_ref' || typeof physical.lineProperty.value !== 'string' || !physical.lineProperty.value.trim()) throw new Error('price_or_configuration_changed');
      prepared.push({ index, quote, properties: { ...line.properties, _bm_ref: physical.lineProperty.value,
        _bm_ctx: JSON.stringify({ ...context, expiresAt: quote.expiresAt }) } });
    }
    // Prepare every line before the first properties write. Old refs are never decoded.
    if (!commit) return initial;
    const expected = structuredClone(initial);
    for (const ready of prepared) {
      ensureVehicle();
      const current = await cartJson('/cart.js', undefined, signal);
      ensureVehicle();
      if (composition(current) !== composition(expected) || !quoteIsFresh(ready.quote)) throw new Error('cart_changed');
      const line = current.items[ready.index];
      const changed = await cartJson(cartChangeAjaxUrl(), { id: line.key, quantity: line.quantity, properties: ready.properties }, signal);
      ensureVehicle();
      expected.items[ready.index].properties = ready.properties;
      if (composition(changed) !== composition(expected)) throw new Error('cart_changed');
    }
    const final = await cartJson('/cart.js', undefined, signal);
    ensureVehicle();
    if (composition(final) !== composition(expected) || prepared.some(ready => !quoteIsFresh(ready.quote))) throw new Error('cart_changed');
    return final;
  }
  window.BandenmeestersNewCart = Object.freeze({ revalidate: revalidateNewCart });
  // Preserve the Bridge's typed refusal without showing internal supplier
  // details or implying a product can be purchased before a certified Quote.
  const newCartFailure = (error) => {
    const code = String(error?.code || error?.message || '');
    if (['quote_policy_unready', 'purchase_not_ready', 'supplier_comparison_unready', 'provider_certification_unready'].includes(code)) {
      return { message: 'We kunnen de levering van je bestelling momenteel niet bevestigen. Er is niets besteld of betaald.', advice: true };
    }
    if (code === 'commerce_policy_unready' || code === 'price_or_configuration_changed') {
      return { message: 'De definitieve prijs of uitvoering kan nu niet worden bevestigd. Er is niets besteld of betaald.', advice: true };
    }
    if (['not_sellable', 'product_compliance_unready'].includes(code)) {
      return { message: 'Dit product is op dit moment niet bestelbaar. Kies een andere uitvoering of vraag persoonlijk advies.', advice: true };
    }
    if (['temporarily_unavailable', 'network_error', 'rate_limited', 'http_429', 'http_503'].includes(code)) {
      return { message: 'De bestelcontrole is tijdelijk niet bereikbaar. Je winkelwagen blijft bewaard; probeer het later opnieuw.', advice: false };
    }
    return { message: 'We kunnen je bestelling nu niet bevestigen. Er is niets besteld of betaald. Vraag gerust persoonlijk advies.', advice: true };
  };
  const newCartMessage = (text, refresh = false, advice = false) => {
    const status = document.getElementById('BmNewCartGate');
    if (status) status.textContent = text;
    const recovery = document.querySelector('[data-bm-new-cart-refresh]');
    if (recovery) recovery.hidden = !refresh;
    const help = document.querySelector('[data-bm-new-cart-help]');
    if (help) help.hidden = !advice;
  };
  async function checkoutNewCart() {
    if (newPreflightBusy || newCartQuantityBusy || newCartQuantityQueued) return;
    newPreflightBusy = true; renderVehicle();
    const postalCode = checkoutPostalCode();
    const deliveryAddress = readCheckoutDelivery();
    rememberDelivery();
    if (!postalCode) {
      newCartMessage('Vul een geldige Belgische postcode in.');
      postcodeField()?.focus();
      newPreflightBusy = false; renderVehicle();
      return;
    }
    newCartMessage('Je bestelling controleren…');
    const needsVehicle = [...document.querySelectorAll('[data-bm-new-cart-line]')].some(row => row.dataset.productType !== 'Nieuwe banden');
    const selectedVehicle = needsVehicle ? window.BandenmeestersVehicle?.getNewVehicle?.()?.vehicleId || '' : null;
    restoreDelivery();
    try {
      const start = Date.now();
      let timeout;
      try {
        await Promise.race([
          Promise.all([...document.querySelectorAll('cart-items,mini-cart')].map(owner => owner.whenSettled?.())),
          new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('cart_busy')), 10000); }),
        ]);
      } finally { clearTimeout(timeout); }
      while (document.querySelector('.bm-cart-page.loading,.mini-cart-wrap.loading,.cart-item-loading-overlay:not(.hidden)')) {
        if (Date.now() - start > 10000) throw new Error('cart_busy');
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      const isDeliveryCurrent = () => checkoutPostalCode() === postalCode && JSON.stringify(readCheckoutDelivery()) === JSON.stringify(deliveryAddress);
      await revalidateNewCart({ commit: true, postalCode, deliveryAddress }, { isDeliveryCurrent });
      if (selectedVehicle !== null && currentNewVehicleId() !== selectedVehicle) throw new Error('vehicle_changed');
      if (!isDeliveryCurrent()) throw new Error('delivery_changed');
      location.assign('/checkout');
    } catch (error) {
      if (error?.message === 'cart_timeout') {
        newCartMessage('De controle duurde te lang. Vernieuw je winkelwagen en probeer opnieuw.', true);
      } else if (error?.message === 'delivery_phone_invalid') {
        newCartMessage('Vul een geldig telefoonnummer in, bijvoorbeeld +32 470 12 34 56. Controleer dit vóór het afrekenen.');
        deliveryFields().find(field => field.dataset.bmNewDeliveryField === 'phone')?.focus?.();
      } else if (error?.message === 'delivery_fields_invalid') {
        newCartMessage('Controleer de ingevulde aflevergegevens: een veld heeft een ongeldig formaat of is te lang.');
      } else if (error?.message === 'delivery_address_required') {
        newCartMessage('Vul je volledige afleveradres en telefoonnummer in.');
        deliveryFields().find(field => !field.value.trim() && field.required)?.focus?.();
      } else if (error?.message === 'delivery_changed') {
        newCartMessage('Je aflevergegevens zijn gewijzigd. Controleer ze en probeer opnieuw.');
      } else if (error?.message === 'vehicle_required') {
        newCartMessage('Kies je auto om de passing van deze NEW-set te controleren.');
      } else if (error?.message === 'fitment_blocked') {
        newCartMessage('Niet geschikt voor jouw auto. Verwijder deze velg of kies een passende maat.');
      } else if (error?.message === 'fitment_required') {
        newCartMessage('We kunnen niet bevestigen dat deze velgen op jouw auto passen. Kies een andere maat of vraag persoonlijk advies.');
      } else if (error?.message === 'cart_changed') {
        newCartMessage('Je winkelwagen is gewijzigd. Vernieuw de winkelwagen en controleer je sets opnieuw.', true);
      } else {
        const refusal = newCartFailure(error);
        newCartMessage(refusal.message, false, refusal.advice);
      }
    } finally { newPreflightBusy = false; renderVehicle(); }
  }

  const init = () => {
    document.addEventListener('click', event => {
      const delta = event.target.closest?.('[data-bm-cart-qty-delta]');
      if (!delta) return;
      event.preventDefault();
      const row = delta.closest('[data-bm-new-cart-line]');
      const current = Number(row?.querySelector?.('[data-bm-cart-qty-input]')?.value);
      const amount = Number(delta.dataset.bmCartQtyDelta);
      if (!row || !Number.isSafeInteger(amount) || Math.abs(amount) !== 1) return;
      queueNewWheelQuantity(row, current + amount);
    }, true);
    document.addEventListener('change', event => {
      if (!event.target.matches?.('[data-bm-cart-qty-input]')) return;
      const row = event.target.closest('[data-bm-new-cart-line]');
      if (row) queueNewWheelQuantity(row, Number(event.target.value));
    }, true);
    document.addEventListener('input', event => { if (event.target.matches?.('[data-bm-new-delivery-field], [data-bm-new-delivery-postcode]')) rememberDelivery(); });
    document.addEventListener('cart:item-quantity-update', restoreDelivery);
    window.addEventListener('pageshow', rememberDelivery);
    renderVehicle();
    window.addEventListener('bm:vehicle:change', renderVehicle);
    document.addEventListener('bm:vehicle:ready', renderVehicle);
    window.addEventListener('pageshow', renderVehicle);
    document.addEventListener('change', event => {
      if (newPreflightBusy && event.target.matches?.('[name="updates[]"]')) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }, true);
    ['cart:item-add', 'cart:item-remove', 'cart:item-quantity-update'].forEach((name) => document.addEventListener(name, () => requestAnimationFrame(renderVehicle)));

    document.addEventListener('submit', event => {
      const checkout = event.target.querySelector?.('[data-bm-cart-checkout]');
      if (!checkout) return;
      renderVehicle();
      if (checkout.disabled) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (checkout.hasAttribute('data-new-blocked')) { event.preventDefault(); event.stopImmediatePropagation(); checkoutNewCart(); }
    }, true);
    document.addEventListener('click', (event) => {
      if ((newPreflightBusy || newCartQuantityBusy || newCartQuantityQueued) && event.target.closest?.('cart-remove-button,quantity-input,[data-bm-cart-checkout]')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (event.target.closest?.('[data-bm-mismatch-ack]')) {
        renderVehicle();
        acknowledgedMismatch = currentMismatch;
        renderVehicle();
        document.querySelector('[data-bm-cart-checkout]')?.focus();
      }
      const vehicleAction = event.target.closest?.('[data-bm-vehicle-change-link]');
      if (vehicleAction && (vehicleAction.closest?.('.bm-cart-page,.bm-mini-cart') || document.body.classList.contains('template-cart'))) {
        event.preventDefault();
        window.BandenmeestersVehicle?.setSelectionReturn?.(window.location.pathname + window.location.search);
        window.miniCart?.close?.();
        if (window.BandenmeestersVehicleSelector?.open) {
          event.stopImmediatePropagation();
          window.BandenmeestersVehicleSelector.open(vehicleAction);
        } else window.location.assign(window.BandenmeestersVehicle?.selectorUrl?.() || '/#voertuigselector');
      }
    }, true);

    const observer = new MutationObserver((mutations) => {
      const cartMarkupChanged = mutations.some((mutation) => [...mutation.addedNodes, ...mutation.removedNodes].some((node) => node.nodeType === 1 && (node.matches?.('[data-bm-cart-vehicle],[data-bm-cart-line],[data-bm-new-cart-line]') || node.querySelector?.('[data-bm-cart-vehicle],[data-bm-cart-line],[data-bm-new-cart-line]'))));
      if (!cartMarkupChanged) return;
      requestAnimationFrame(renderVehicle);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
